import { Maybe } from '@pylot-data/pylotschema'

export const sortAlphabetically = (
    a: Maybe<string> | undefined,
    b: Maybe<string> | undefined
): number => {
    if (a! < b!) {
        return -1
    }

    if (a! > b!) {
        return 1
    }

    return 0
}
